import React from "react";
import PageContainer from "./container/PageContainer";
import "./App.css";
import WhatsAppIcon from "./components/WhatsAppIcon/WhatsAppIcon";
import StickyMobileBar from "./components/StickyMobileBar/StickyMobileBar";
import Routers from "./router/Routers";

function App() {
  return (
    <>
      <WhatsAppIcon />
      <StickyMobileBar />
      <PageContainer>
        <Routers />
      </PageContainer>
    </>
  );
}

export default App;
